<template>
    <AppFormValidator
        ref="validator"
        :model="model">
        <CForm @submit.prevent>
            <CRow form class="form-group">
                <CCol
                    tag="label"
                    sm="3"
                    class="col-form-label">Башня</CCol>
                <CCol sm="9">
                    <CSelect
                        inline
                        :value.sync="model.tower_id"
                        :options="towers"
                        placeholder="Башня..."
                    />
                </CCol>
            </CRow>

            <CRow form class="form-group">
                <CCol
                    tag="label"
                    sm="3"
                    class="col-form-label">Консьерж</CCol>
                <CCol sm="9">
                    <CSelect
                        inline
                        :value.sync="model.concierge_id"
                        :options="concierges"
                        placeholder="Консьерж..."
                    />
                </CCol>
            </CRow>

            <CInput
                v-model="model.floor"
                horizontal
                label="Этаж"
                placeholder="Введите этаж" />
                
            <CInput
                v-model="model.appartment"
                horizontal
                label="Апартаменты"
                placeholder="Введите апартаменты" />
            <CInput
                v-model="model.delivery_type"
                horizontal
                label="Тип доставки"
                placeholder="Введите тип доставки" />

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Время доставки</span>
            <span class="w-2/3">
                {{ model.created_at }}
            </span>
        </div>

            <div class="flex mt-4">
                <CButton color="primary" @click="submit">{{ submitButtonTitle }}
                </CButton>
                <CButton
                    v-if="model.id"
                    variant="outline"
                    color="danger"
                    class="ml-4"
                    @click="promptDelete">Удалить
                </CButton>
            </div>
        </CForm>

        <AppConfirmDialog
            ref="confirmDialog"
            title="Подтверждение"
            color="danger"
            text="Вы действительно хотите удалить запись? Это действие нельзя будет отменить."
            @confirm="confirmDelete" />
    </AppFormValidator>
</template>

<script>
    import Vue from 'vue';
    import to from 'await-to-js';
    import { morphism } from 'morphism';
    import AppFormValidator from '@/components/AppFormValidator';
    import AppConfirmDialog from '@/components/AppConfirmDialog';
    const moment = require('moment');

    export default {
        components: {
            AppFormValidator,
            AppConfirmDialog,
        },

        props: {
            entity: {
                type: Object,
                default: () => ({}),
            },
        },

        data() {
            return {
                isAuthorized: false,
                model: {},
                schema: {
                    id: 'id',
                    concierge_id: 'concierge_id',
                    floor: 'floor',
                    appartment: 'appartment',
                    delivery_type: 'delivery_type',
                    tower_id: 'tower_id',
                    updated_at: 'updated_at',
                    created_at: 'created_at'
                },
                list: [],

                towers:[],
                concierges: [],

                deleteModal: false,
                disabledModal: false,
            };
        },

        computed: {
            submitButtonTitle() {
                return typeof this.entity.id === 'number' ? 'Сохранить' : 'Создать';
            },
        },

        async mounted(){
            try {
                const id = this.$route.params.id;
                if (id) {
                    const delivery = await this.axios.get('/other-delivery/' + id);
                    if(delivery?.data?.updated_at) {
                        this.model.updated_at = moment(delivery.data.updated_at).format('YYYY-MM-DD HH:mm:ss');
                    }
                    if(delivery?.data?.created_at) {
                        this.model.created_at = moment(delivery.data.created_at).format('YYYY-MM-DD HH:mm:ss');
                    }
                }
            } catch (e) {
                this.$root.$emit('showError', 'Ошибка при загрузке данных ' + e);
            }
        },

        created() {
            this.setModel();
            this.initEntities();
        },

        methods: {
            setModel() {
                this.model = morphism(this.schema, this.entity);
            },

            async submit() {
                const [error] = await to(this.$refs.validator.validate());

                if (error) {
                    return false;
                }

                const { id, ...payload } = this.model;

                payload.concierge_id = payload.concierge_id ? +payload.concierge_id : null;
                payload.floor = payload.floor ? payload.floor : '';
                payload.appartment = payload.appartment ? payload.appartment : '';
                payload.delivery_type = payload.delivery_type ? payload.delivery_type : '';
                payload.tower_id = payload.tower_id ? +payload.tower_id : null;

                payload.updated_at = moment().format('YYYY-MM-DD HH:mm:ss');

                if (typeof id === 'number') {
                    const [err] = await to(this.axios.put(`/other-deliveries/update/${id}`, payload));
                    if (err) {
                        return this.$root.$emit('showError', 'Ошибка. Не удалось сохранить запись.');
                    }
                } else {
                    const [err] = await to(this.axios.post('/other-deliveries/create', payload));
                    if (err) {
                        return this.$root.$emit('showError', 'Ошибка. Не удалось создать новую запись.');
                    }
                }

                this.$emit('success');
            },

            promptDelete() {
                this.$refs.confirmDialog.open();
            },

            async confirmDelete() {
                if (!this.model.id) {
                    return false;
                }

                const [error] = await to(
                    this.axios.delete(`/other-deliveries/${this.model.id}`)
                );

                if (error) {
                    return this.$root.$emit('showError', 'Ошибка удаления записи.');
                }

                this.$emit('deleted');
            },

            async initEntities() {
                if (!this.towers.length) {
                    const towers = [{ value: null, label: 'Башня...' }];
                    const tows = await Vue.axios.get('/address')
                    tows.data.forEach(tower => {
                        towers.push({ value: tower.id, label: tower.name });
                    });
                    this.towers = towers;
                }

                if (!this.concierges.length) {
                    const concierges = [{ value: null, label: 'Консьерж...' }];
                    const cons = await Vue.axios.get('/concierges');

                    if (cons.data?.results?.length > 0) {
                        cons.data.results.forEach(c => {
                            concierges.push({ value: c.id, label: c.name });
                        });
                    }
                    this.concierges = concierges;
                }
            },
        },
    };
</script>
<style>
input.custom-datepicker {
    padding: 0.375rem 0.75rem;
    border-radius: 0.25rem;
    border: 1px solid;
    border-color: #d8dbe0;
    width: 100%;
}
</style>
